import React from 'react';
import {GlobalStyles} from '@mui/system';
import ClashDisplaySemibold from 'assets/fonts/ClashDisplay-Semibold.ttf'
import BarlowRegular from 'assets/fonts/Barlow-Regular.ttf';

const GlobalStylesComponent = () => {
    return (
        <GlobalStyles
            styles={(theme) => ({
                '@font-face': [
                    {
                        fontFamily: 'Clash Display Semibold',
                        src: `url(${ClashDisplaySemibold}) format('ttf')`,
                        fontWeight: 600,
                        fontStyle: 'normal',
                    },
                    {
                        fontFamily: 'Barlow',
                        src: `url(${BarlowRegular}) format('ttf')`,
                        fontWeight: 400,
                        fontStyle: 'normal',
                    },
                ],
                body: {
                    margin: 0,
                    padding: 0,
                    backgroundColor: theme.palette.primary.main,
                    fontFamily: '"Barlow", sans-serif',
                },
                h1: {
                    fontFamily: '"Clash Display Semibold", sans-serif',
                    // color: '#faf0dc',
                },
                a: {
                    // color: '#0fe880',
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                },
                p: {
                    // color: '#606060',
                    fontFamily: '"Barlow", sans-serif',
                },

            })}
        />
    );
};

export default GlobalStylesComponent;
